import { PermsService } from './../../../../services/utils/perms.service';
import { PermissionConfiguration } from './../../../../models/permission.model';
import { EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomerFileUpload } from './../../../../models/customer.model';
import { Observable } from 'rxjs';
import { CustomerInfoService } from './../../../../services/customer/customerinfo.service';
import { FileUpload, MessageService, SelectItem } from 'primeng/primeng';

import { Component, Input, OnInit,ViewChild } from '@angular/core';

declare var Stimulsoft: any;
declare var $: any;

@Component({  
  selector: 'app-upload-mg-fatture-premi',
  templateUrl: './uploadmgfatturepremi.component.html',
  providers: [],
})
export class Uploadmgfatturepremi implements OnInit {
  
  @Input() codice_cliente: string;
  @Input() num_reservation: string;
  @Input() customerId: string;
  @Input() card_no: string;
  @Input() surname: string;
  @Input() name: string;

  @Input() permissions: any;
  @Input() reqDownloadPermission: PermissionConfiguration = null;
  @Input() reqUploadPermission: PermissionConfiguration = null;
  
  
  

  @Output() onCloseModal: EventEmitter<boolean> = new EventEmitter<boolean>();  
  
  @ViewChild('upload') upload: FileUpload;

  file: File = null;

  currentExistingFiles: Array<CustomerFileUpload> = new Array<CustomerFileUpload>();
    
  translations: any;  
  
  show = {
    customerInfo: false,
    available: false,
    download: false,
    upload: false
  }    

  constructor(
    private notifyService: MessageService,
    private srvCust: CustomerInfoService,    
    private translate: TranslateService,
    public srvPermission: PermsService 
  ) { }
  ngOnInit(): void {           
    if(this.permissions.length > 0 && this.reqDownloadPermission && this.reqUploadPermission){
      this.show.download = this.srvPermission.checkPermission(this.permissions,this.reqDownloadPermission);
      this.show.upload = this.srvPermission.checkPermission(this.permissions,this.reqUploadPermission);      
    }

    const translateObs = this.translate.get([
      'common.all',
      'common.company',
      'common.physicalPerson',
      'common.status_notDeleted',
      'common.status_onlyDeleted',     
      'upload.upload_success',
      'upload.upload_error',
      'upload.type_error',
      'upload.choose_file',
      'upload.download_error'
    ]);

    var CHECKSTORAGEAVILABILITY = this.srvCust.chackStorageAvailability(this.customerId);    
    var GETFILES = this.srvCust.getFiles(this.customerId,encodeURIComponent("reservations\\premi\\" + this.num_reservation));
    var self = this;

    Observable.zip(
      CHECKSTORAGEAVILABILITY,      
      GETFILES,
      translateObs
      )
    .subscribe(([
      resCheck,            
      resGetFiles,
      t]) => {          
          if(resCheck && !resCheck.error){
            self.show.available = true;
          }
          else{
            self.show.available = false;
          }

          self.translations = t;
          
          if(resGetFiles && resGetFiles.history){
            self.currentExistingFiles = resGetFiles.history;
          }          

          self.show.customerInfo = true;
        });
  }
  onClearUpload(){
    this.file = null;
  }
  onFileUpload(event, upload) {
    if(event.files[0].type == "application/pdf"){
        var self = this;
      setTimeout(function(){
        self.upload = upload;
        self.file = event.files[0];
      },100);
    }
    else{
      this.notifyService.add({ severity: 'error', detail: this.translations['upload.type_error'] });
    }

  } 
  onClickSave(){

    if(this.file){

      if(this.file.type == "application/pdf"){
        var self = this;
        this.srvCust.uploadMgFile(this.file,this.customerId,encodeURIComponent("reservations\\premi\\" + this.num_reservation)).subscribe(res=>{

          if(res){
            self.notifyService.add({severity: 'success', detail: this.translations['upload.upload_success']});
            self.currentExistingFiles.unshift(res);

          }
          else{
            self.notifyService.add({severity: 'error', detail: this.translations['upload.upload_error']});
            self.onClearUpload();
          }
          self.upload.clear();
          self.onClearUpload();
        });
      }

    }
  }
  onClickShowFile(currentExistingfile: CustomerFileUpload){
    var self = this;
    this.srvCust.getFileByBase64(this.customerId,currentExistingfile.storageFileName,encodeURIComponent("reservations\\premi\\" + this.num_reservation)).subscribe(res=>{
      if(res){                
        var blob = new Blob([res], {type: "application/pdf"});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = currentExistingfile.originalFileName;
        link.download = fileName;
        link.click();
      }
      else{
        self.notifyService.add({severity: 'error', detail: this.translations['upload.download_error']});
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/upload-mg-fatture-premi/uploadmgfatturepremi.component.ts